import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Banner from '../Component/Blog/Banner'
import ListingBlog from '../Component/Blog/ListingBlog'
import BrandSection from '../Component/HomePage/BrandSection'
import Footer from '../Component/NavBarFooter/Footer'
import blogData from '../Data/blogData.json'
function Blog() {
  
  return (
    <div>
        <NavBar/>
        <Banner/>
        <ListingBlog blogData={blogData}/>
        <BrandSection/>
        <Footer/>

    </div>
  )
}

export default Blog